import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import { Badge, Button, Col, Divider, Form, IconButton, Input, InputGroup, Loader, Message, Modal, Nav, Panel, Radio, RadioGroup, Row, Stack, Table, Uploader, useToaster } from 'rsuite';
import axios from "axios";
import RefreshIcon from '@rsuite/icons/legacy/Refresh';
import SearchIcon from '@rsuite/icons/Search';
import RefreshImageIcon from '@rsuite/icons/CloudReflash';

const { Column, HeaderCell, Cell } = Table;

function previewFile(file, callback) {
    const reader = new FileReader();
    reader.onloadend = () => callback(reader.result);
    reader.readAsDataURL(file);
}

const ImageCell = ({ rowData, dataKey, ...props }) => {
    const [uploading, setUploading] = React.useState(false);
    const [fileInfo, setFileInfo] = React.useState(null);
    const toaster = useToaster();

    return (
        <Cell {...props} style={{ padding: 0 }}>
            <div
                style={{
                    width: 70,
                    height: 70,
                    background: '#f5f5f5',
                    borderRadius: 6,
                    marginTop: 4,
                    overflow: 'hidden',
                    display: 'inline-block'
                }}
            >
                <Uploader
                    accept="image/png"
                    multiple={false}
                    draggable={true}
                    fileListVisible={false}
                    listType="picture"
                    headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                    action={rowData.uploadURL}
                    onUpload={file => {
                        setUploading(true);
                        previewFile(file.blobFile, value => { setFileInfo(value); });
                    }}
                    onSuccess={(response, file) => {
                        setUploading(false);
                        toaster.push(<Message type="success">Actualizado correctamente</Message>);
                        console.log(response);
                    }}
                    onError={() => {
                        setFileInfo(null);
                        setUploading(false);
                        toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                    }}
                >
                    <button style={{ width: 62, height: 62, background: '#f5f5f5', marginTop: 4 }}>
                        {uploading && <Loader backdrop center />}
                        {fileInfo ?
                            (<img src={fileInfo} width="100%" height="100%" />) :
                            (<img src={rowData.image} width="100%" height="100%" />)}
                    </button>
                </Uploader>
            </div>
        </Cell>
    )
}
const ImageCellProduct = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
        <div className="view-list-image-item">
            <img src={rowData[dataKey]} width="80" alt="product" loading="lazy" />
        </div>
    </Cell>
);

function Settings({ setWorking }) {
    const user = useSelector(state => state.auth.user)
    const site = useSelector(state => state.site);
    const params = useSelector(state => state.params);
    const apiURL = site.site.apiServer;
    const [articulos, setArticulos] = useState([]);
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();

    const [active, setActive] = React.useState('brand');
    const toaster = useToaster();
    const [uploading_40, setUploading_40] = React.useState(false);
    const [uploading_80, setUploading_80] = React.useState(false);
    const [uploading_150, setUploading_150] = React.useState(false);
    const [fileInfo_40, setFileInfo_40] = React.useState(null);
    const [fileInfo_80, setFileInfo_80] = React.useState(null);
    const [fileInfo_150, setFileInfo_150] = React.useState(null);

    const [uploading_bg, setUploading_bg] = React.useState(false);
    const [fileInfo_bg, setFileInfo_bg] = React.useState(null);
    const [uploading_header, setUploading_header] = React.useState(false);
    const [fileInfo_header, setFileInfo_header] = React.useState(null);
    const [uploading_itemBG, setUploading_itemBG] = React.useState(false);
    const [fileInfo_itemBG, setFileInfo_itemBG] = React.useState(null);
    const [uploading_itemBG_NoPrice, setUploading_itemBG_NoPrice] = React.useState(false);
    const [fileInfo_itemBG_NoPrice, setFileInfo_itemBG_NoPrice] = React.useState(null);
    const [applyFilter, setApplyFilter] = useState(false);
    const [uploading_Cover, setUploading_Cover] = React.useState(false);
    const [fileInfo_Cover, setFileInfo_Cover] = React.useState(null);

    const [uploading_Cover2, setUploading_Cover2] = React.useState(false);
    const [fileInfo_Cover2, setFileInfo_Cover2] = React.useState(null);

    const [uploading_Backcover, setUploading_Backcover] = React.useState(false);
    const [fileInfo_Backcover, setFileInfo_Backcover] = React.useState(null);

    const [rubros, setRubros] = useState([]);
    const [subRubros, setSubRubros] = useState([]);

    const [filterArticulo, setFilterArticulo] = useState("");
    const [filterRubro, setFilterRubro] = useState("");
    const [filterSubRubro, setFilterSubRubro] = useState("");
    const [filterPhoto, setFilterPhoto] = useState("A");
    const [dataArticulos, setDataArticulos] = useState([]);

    const handleSortColumn = (sc, st) => {
        if (sc && st) {
            setArticulos([...articulos].sort((a, b) => {
                let x = a[sortColumn], y = b[sortColumn];
                if (typeof x === 'string')
                    x = x.charCodeAt();
                if (typeof y === 'string')
                    y = y.charCodeAt();
                return sortType === 'asc' ? x - y : y - x;
            }));
        }
        setSortColumn(sc);
        setSortType(st);
    };

    const fetchData = async () => {
        axios
            .get(apiURL + "/rubro", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((resp) => {
                resp.data.data.map((x) => {
                    x.image = `${site.site.apiServer}/catalogo/res/logo-header?id=${x.value}&type=rubro`;
                    x.uploadURL = `${apiURL}/catalogo/res/logo-header?id=${x.value}&type=rubro`;
                });
                console.log(resp);
                setRubros(resp.data.data);
            })
            .catch((e) => {
                console.log(e);
            });
        axios
            .get(apiURL + "/subrubro", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((resp) => {
                resp.data.data.map((x) => {
                    x.image = `${site.site.apiServer}/catalogo/res/logo-header?id=${x.value}&type=subrubro`;
                    x.uploadURL = `${apiURL}/catalogo/res/logo-header?id=${x.value}&type=subrubro`;
                });
                console.log(resp);
                setSubRubros(resp.data.data);
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const fetchDataArticulos = async () => {
        axios
            .get(apiURL + "/articulo?t=complete", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((resp) => {
                console.log(resp);
                resp.data.data.map((x) => {
                    x.image = `${site.site.apiServer}/articulo/${x.image}`
                });
                //setArticulos(resp.data.data);
                setDataArticulos(resp.data.data);
                setApplyFilter(!applyFilter);
            })
            .catch((e) => {
                console.log(e);
            });
    }
    const fetchReloadPhoto = async () => {
        setWorking(true);
        axios
            .get(apiURL + "/articulo/reloadphotos", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((resp) => {
                console.log(resp);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(async () => {
                await fetchDataArticulos();
                setWorking(false);
            });
    }

    useEffect(() => {
        let art = [...dataArticulos];
        if (filterArticulo.length > 0) {
            art = art.filter(i => i.label.toLowerCase().includes(filterArticulo))
        }
        if (filterRubro.length > 0) {
            art = art.filter(i => i.rubro.toLowerCase().includes(filterRubro))
        }
        if (filterSubRubro.length > 0) {
            art = art.filter(i => i.subrubro.toLowerCase().includes(filterSubRubro))
        }
        if (filterPhoto === 'B') {
            art = art.filter(i => i.imageID !== 'nophoto')
        } else if (filterPhoto === 'C') {
            art = art.filter(i => i.imageID === 'nophoto')
        }
        setArticulos(art);
    }, [filterArticulo, filterRubro, filterSubRubro, filterPhoto, applyFilter]);
    useEffect(() => {
        console.log('Settings begin');
        fetchData();
        return () => { console.log('Settings end'); }
    }, []);
    useEffect(() => {
        console.log('Active change init');
        if (active === 'fotos' && articulos.length === 0)
            fetchDataArticulos();
        return () => { console.log('Active change end'); }
    }, [active]);

    return (
        <>
            <Panel header={<Stack alignItems="baseline" spacing={10}>
                <Stack.Item grow={1}>
                    <h4 className="title">Ajustes</h4>
                </Stack.Item>
                <Button appearance="subtle" startIcon={<RefreshIcon />} onClick={() => { }} style={{display: "none"}}>
                    Actualizar
                </Button>
            </Stack>} bordered>
                {user.role.includes('admin') && (
                    <Row>
                        <Col md={4}>
                            <Nav appearance="subtle" vertical activeKey={active} onSelect={setActive} >
                                <Nav.Item eventKey="brand">Empresa</Nav.Item>
                                <Nav.Item eventKey="ajustes">Ajustes de vista PDF</Nav.Item>
                                <Nav.Item eventKey="rubros">Iconos de rubros</Nav.Item>
                                <Nav.Item eventKey="subrubros">Iconos de subrubros</Nav.Item>
                                <Nav.Item eventKey="fotos">Fotos de art&iacute;culos</Nav.Item>
                            </Nav>
                        </Col>
                        {active === 'brand' && (
                            <Col md={16} mdOffset={2}>
                                <h5>Logo de la empresa</h5>
                                <Divider />
                                <Stack spacing={20} direction="row" alignItems="center" justifyContent="flex-start">
                                    <Stack spacing={20} direction="column" alignItems="center" justifyContent="flex-start">
                                        <div style={{ width: 170, height: 170, textAlign: 'center' }}>
                                            <Uploader
                                                accept="image/png"
                                                multiple={false}
                                                draggable={true}
                                                fileListVisible={false}
                                                listType="picture"
                                                headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                                action={`${apiURL}/params/brand/logo/logo160`}
                                                onUpload={file => {
                                                    setUploading_150(true);
                                                    previewFile(file.blobFile, value => { setFileInfo_150(value); });
                                                }}
                                                onSuccess={(response, file) => {
                                                    setUploading_150(false);
                                                    toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                    console.log(response);
                                                }}
                                                onError={() => {
                                                    setFileInfo_150(null);
                                                    setUploading_150(false);
                                                    toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                                }}
                                            >
                                                <button style={{ width: 160, height: 160 }}>
                                                    {uploading_150 && <Loader backdrop center />}
                                                    {fileInfo_150 ?
                                                        (<img src={fileInfo_150} width="100%" height="100%" />) :
                                                        (<img src={params && params.brand && params.brand.logo160 ? params.brand.logo160 : ''} width="100%" height="100%" />)}
                                                </button>
                                            </Uploader>
                                        </div>
                                        <p>
                                            Resoluci&oacute;n 160 x 160 px
                                        </p>
                                    </Stack>
                                    <Stack spacing={20} direction="column" alignItems="center" justifyContent="flex-start">
                                        <div style={{ width: 170, height: 170, textAlign: 'center' }}>
                                            <Uploader
                                                accept="image/png"
                                                multiple={false}
                                                draggable={true}
                                                fileListVisible={false}
                                                listType="picture"
                                                headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                                action={`${apiURL}/params/brand/logo/logo80`}
                                                onUpload={file => {
                                                    setUploading_80(true);
                                                    previewFile(file.blobFile, value => { setFileInfo_80(value); });
                                                }}
                                                onSuccess={(response, file) => {
                                                    setUploading_80(false);
                                                    toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                    console.log(response);
                                                }}
                                                onError={() => {
                                                    setFileInfo_80(null);
                                                    setUploading_80(false);
                                                    toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                                }}
                                            >
                                                <button style={{ width: 80, height: 80 }}>
                                                    {uploading_80 && <Loader backdrop center />}
                                                    {fileInfo_80 ?
                                                        (<img src={fileInfo_80} width="100%" height="100%" />) :
                                                        (<img src={params && params.brand && params.brand.logo80 ? params.brand.logo80 : ''} width="100%" height="100%" />)}
                                                </button>
                                            </Uploader>
                                        </div>
                                        <p>
                                            Resoluci&oacute;n 80 x 80 px
                                        </p>
                                    </Stack>
                                    <Stack spacing={20} direction="column" alignItems="center" justifyContent="flex-start">
                                        <div style={{ width: 170, height: 170, textAlign: 'center' }}>
                                            <Uploader
                                                accept="image/png"
                                                multiple={false}
                                                draggable={true}
                                                fileListVisible={false}
                                                listType="picture"
                                                headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                                action={`${apiURL}/params/brand/logo/logo40`}
                                                onUpload={file => {
                                                    setUploading_40(true);
                                                    previewFile(file.blobFile, value => { setFileInfo_40(value); });
                                                }}
                                                onSuccess={(response, file) => {
                                                    setUploading_40(false);
                                                    toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                    console.log(response);
                                                }}
                                                onError={() => {
                                                    setFileInfo_40(null);
                                                    setUploading_40(false);
                                                    toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                                }}
                                            >
                                                <button style={{ width: 40, height: 40 }}>
                                                    {uploading_40 && <Loader backdrop center />}
                                                    {fileInfo_40 ?
                                                        (<img src={fileInfo_40} width="100%" height="100%" />) :
                                                        (<img src={params && params.brand && params.brand.logo40 ? params.brand.logo40 : ''} width="100%" height="100%" />)}
                                                </button>
                                            </Uploader>
                                        </div>
                                        <p>
                                            Resoluci&oacute;n 40 x 40 px
                                        </p>
                                    </Stack>
                                </Stack>
                                <h5 style={{ marginTop: 30 }}>Informaci&oacute;n de la empresa</h5>
                                <Divider />
                                <Form>
                                    <Form.Group controlId="email-5">
                                        <Form.Control name="name" placeholder="Nombre de empresa" style={{ width: 600 }} />
                                    </Form.Group>
                                    <Form.Group controlId="name-5">
                                        <Form.Control name="web" placeholder="Sitio web" style={{ width: 600 }} />
                                    </Form.Group>
                                </Form>
                            </Col>
                        )}
                        {active === 'ajustes' && (
                            <Col md={16} mdOffset={2}>
                                <h5>Fondo de p&aacute;gina</h5>
                                <Divider />
                                <div style={{ width: 400, height: 570, textAlign: 'center' }}>
                                    <Uploader
                                        accept="image/jpeg"
                                        multiple={false}
                                        draggable={true}
                                        fileListVisible={false}
                                        listType="picture"
                                        headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                        action={`${apiURL}/catalogo/res/background`}
                                        onUpload={file => {
                                            setUploading_bg(true);
                                            previewFile(file.blobFile, value => { setFileInfo_150(value); });
                                        }}
                                        onSuccess={(response, file) => {
                                            setUploading_bg(false);
                                            toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                            console.log(response);
                                        }}
                                        onError={() => {
                                            setFileInfo_bg(null);
                                            setUploading_bg(false);
                                            toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                        }}
                                    >
                                        <button style={{ width: 389, height: 561 }}>
                                            {uploading_bg && <Loader backdrop center />}
                                            {fileInfo_bg ?
                                                (<img src={fileInfo_bg} width="100%" height="100%" />) :
                                                (<img src={`${apiURL}/catalogo/res/background`} width="100%" height="100%" />)}
                                        </button>
                                    </Uploader>
                                </div>
                                <p>
                                    Im&aacute;gen JPG - Resoluci&oacute;n 794 x 1122 px
                                </p>
                                <h5 style={{ marginTop: 30 }}>Encabezado de p&aacute;gina</h5>
                                <Divider />
                                <div style={{ width: 790, height: 150, textAlign: 'center' }}>
                                    <Uploader
                                        accept="image/jpeg"
                                        multiple={false}
                                        draggable={true}
                                        fileListVisible={false}
                                        listType="picture"
                                        headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                        action={`${apiURL}/catalogo/res/header`}
                                        onUpload={file => {
                                            setUploading_header(true);
                                            previewFile(file.blobFile, value => { setFileInfo_150(value); });
                                        }}
                                        onSuccess={(response, file) => {
                                            setUploading_header(false);
                                            toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                            console.log(response);
                                        }}
                                        onError={() => {
                                            setFileInfo_header(null);
                                            setUploading_header(false);
                                            toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                        }}
                                    >
                                        <button style={{ width: 778, height: 137 }}>
                                            {uploading_header && <Loader backdrop center />}
                                            {fileInfo_header ?
                                                (<img src={fileInfo_header} width="100%" height="100%" />) :
                                                (<img src={`${apiURL}/catalogo/res/header`} width="100%" height="100%" />)}
                                        </button>
                                    </Uploader>
                                </div>
                                <p>
                                    Im&aacute;gen JPG - Resoluci&oacute;n 794 x 137 px
                                </p>



                                <Stack wrap spacing={20}>
                                    <div style={{ width: 250, textAlign: 'center' }}>
                                        <h5 style={{ marginTop: 30 }}>Fondo de art&iacute;culo con precio</h5>
                                        <Divider />
                                        <Uploader
                                            accept="image/png"
                                            multiple={false}
                                            draggable={true}
                                            fileListVisible={false}
                                            listType="picture"
                                            headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                            action={`${apiURL}/catalogo/res/item-background`}
                                            onUpload={file => {
                                                setUploading_itemBG(true);
                                                previewFile(file.blobFile, value => { setFileInfo_40(value); });
                                            }}
                                            onSuccess={(response, file) => {
                                                setUploading_itemBG(false);
                                                toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                console.log(response);
                                            }}
                                            onError={() => {
                                                setFileInfo_itemBG(null);
                                                setUploading_itemBG(false);
                                                toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                            }}
                                        >
                                            <button style={{ width: 177, height: 262 }}>
                                                {uploading_itemBG && <Loader backdrop center />}
                                                {fileInfo_itemBG ?
                                                    (<img src={fileInfo_itemBG} width="100%" height="100%" />) :
                                                    (<img src={`${apiURL}/catalogo/res/item-background`} width="100%" height="100%" />)}
                                            </button>
                                        </Uploader>
                                        <p>
                                            Im&aacute;gen PNG - Resoluci&oacute;n 177 x 262 px
                                        </p>
                                    </div>


                                    <div style={{ width: 250, textAlign: 'center', minHeight: 370 }}>
                                        <h5 style={{ marginTop: 30 }}>Fondo de art&iacute;culo sin precio</h5>
                                        <Divider />
                                        <Uploader
                                            accept="image/png"
                                            multiple={false}
                                            draggable={true}
                                            fileListVisible={false}
                                            listType="picture"
                                            headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                            action={`${apiURL}/catalogo/res/item-background-noprice`}
                                            onUpload={file => {
                                                setUploading_itemBG_NoPrice(true);
                                                previewFile(file.blobFile, value => { setFileInfo_itemBG_NoPrice(value); });
                                            }}
                                            onSuccess={(response, file) => {
                                                setUploading_itemBG_NoPrice(false);
                                                toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                console.log(response);
                                            }}
                                            onError={() => {
                                                setUploading_itemBG_NoPrice(false);
                                                setFileInfo_itemBG_NoPrice(null);
                                                toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                            }}
                                        >
                                            <button style={{ width: 177, height: 216 }}>
                                                {uploading_itemBG_NoPrice && <Loader backdrop center />}
                                                {fileInfo_itemBG_NoPrice ?
                                                    (<img src={fileInfo_itemBG_NoPrice} width="100%" height="100%" />) :
                                                    (<img src={`${apiURL}/catalogo/res/item-background-noprice`} width="100%" height="100%" />)}
                                            </button>
                                        </Uploader>
                                        <p>
                                            Im&aacute;gen PNG - Resoluci&oacute;n 177 x 216 px
                                        </p>
                                    </div>
                                </Stack>

                                <Stack wrap spacing={20}>
                                    <div style={{ width: 400, textAlign: 'center' }}>
                                        <h5 style={{ marginTop: 30 }}>Tapa de cat&aacute;logo</h5>
                                        <Divider />
                                        <Uploader
                                            accept="image/jpeg"
                                            multiple={false}
                                            draggable={true}
                                            fileListVisible={false}
                                            listType="picture"
                                            headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                            action={`${apiURL}/catalogo/res/cover`}
                                            onUpload={file => {
                                                setUploading_Cover(true);
                                                previewFile(file.blobFile, value => { setFileInfo_Cover(value); });
                                            }}
                                            onSuccess={(response, file) => {
                                                setUploading_Cover(false);
                                                toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                console.log(response);
                                            }}
                                            onError={() => {
                                                setUploading_Cover(false);
                                                setFileInfo_Cover(null);
                                                toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                            }}
                                        >
                                            <button style={{ width: 389, height: 561 }}>
                                                {uploading_Cover && <Loader backdrop center />}
                                                {fileInfo_Cover ?
                                                    (<img src={fileInfo_Cover} width="100%" height="100%" />) :
                                                    (<img src={`${apiURL}/catalogo/res/cover`} width="100%" height="100%" />)}
                                            </button>
                                        </Uploader>
                                        <p>
                                            Im&aacute;gen JPG - Resoluci&oacute;n 794 x 1122 px
                                        </p>
                                    </div>
                                    <div style={{ width: 400, textAlign: 'center' }}>
                                        <h5 style={{ marginTop: 30 }}>Contratapa de cat&aacute;logo</h5>
                                        <Divider />
                                        <Uploader
                                            accept="image/jpeg"
                                            multiple={false}
                                            draggable={true}
                                            fileListVisible={false}
                                            listType="picture"
                                            headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                            action={`${apiURL}/catalogo/res/back-cover`}
                                            onUpload={file => {
                                                setUploading_Backcover(true);
                                                previewFile(file.blobFile, value => { setFileInfo_Backcover(value); });
                                            }}
                                            onSuccess={(response, file) => {
                                                setUploading_Backcover(false);
                                                toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                                console.log(response);
                                            }}
                                            onError={() => {
                                                setUploading_Backcover(false);
                                                setFileInfo_Backcover(null);
                                                toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                            }}
                                        >
                                            <button style={{ width: 389, height: 561 }}>
                                                {uploading_Backcover && <Loader backdrop center />}
                                                {fileInfo_Backcover ?
                                                    (<img src={fileInfo_Backcover} width="100%" height="100%" />) :
                                                    (<img src={`${apiURL}/catalogo/res/back-cover`} width="100%" height="100%" />)}
                                            </button>
                                        </Uploader>
                                        <p>
                                            Im&aacute;gen JPG - Resoluci&oacute;n 794 x 1122 px
                                        </p>
                                    </div>
                                </Stack>

                                <div style={{ width: 400, textAlign: 'center' }}>
                                    <h5 style={{ marginTop: 30 }}>Hoja de proveedores</h5>
                                    <Divider />
                                    <Uploader
                                        accept="image/jpeg"
                                        multiple={false}
                                        draggable={true}
                                        fileListVisible={false}
                                        listType="picture"
                                        headers={{ Authorization: 'Bearer ' + JSON.parse(atob(localStorage.getItem("token"))).at }}
                                        action={`${apiURL}/catalogo/res/cover-2`}
                                        onUpload={file => {
                                            setUploading_Cover2(true);
                                            previewFile(file.blobFile, value => { setFileInfo_Cover2(value); });
                                        }}
                                        onSuccess={(response, file) => {
                                            setUploading_Cover2(false);
                                            toaster.push(<Message type="success">Actualizado correctamente</Message>);
                                            console.log(response);
                                        }}
                                        onError={() => {
                                            setUploading_Cover2(false);
                                            setFileInfo_Cover2(null);
                                            toaster.push(<Message type="error">Error en actualizaci&oacute;n</Message>);
                                        }}
                                    >
                                        <button style={{ width: 389, height: 561 }}>
                                            {uploading_Cover2 && <Loader backdrop center />}
                                            {fileInfo_Cover2 ?
                                                (<img src={fileInfo_Cover2} width="100%" height="100%" />) :
                                                (<img src={`${apiURL}/catalogo/res/cover-2`} width="100%" height="100%" />)}
                                        </button>
                                    </Uploader>
                                    <p>
                                        Im&aacute;gen JPG - Resoluci&oacute;n 794 x 1122 px
                                    </p>
                                </div>

                            </Col>
                        )}
                        {active === 'rubros' && (
                            <Col md={16} mdOffset={2}>
                                <Table autoHeight={true} data={rubros} id="tableRubros" rowHeight={80}>
                                    <Column width={120} align="center">
                                        <HeaderCell>Logo 60x60</HeaderCell>
                                        <ImageCell dataKey="image" />
                                    </Column>
                                    <Column flexGrow={1}>
                                        <HeaderCell>Rubro</HeaderCell>
                                        <Cell dataKey="label" style={{ lineHeight: "50px" }} />
                                    </Column>
                                </Table>
                            </Col>
                        )}
                        {active === 'subrubros' && (
                            <Col md={16} mdOffset={2}>
                                <Table autoHeight={true} data={subRubros} id="tableSubrubros" rowHeight={80}>
                                    <Column width={120} align="center">
                                        <HeaderCell>Logo 60x60</HeaderCell>
                                        <ImageCell dataKey="image" />
                                    </Column>
                                    <Column flexGrow={1}>
                                        <HeaderCell>Subrubro</HeaderCell>
                                        <Cell dataKey="label" style={{ lineHeight: "50px" }} />
                                    </Column>
                                </Table>
                            </Col>
                        )}
                        {active === 'fotos' && (
                            <Col md={16} mdOffset={2}>
                                <Stack spacing={10} justifyContent="space-between" direction="row" style={{marginBottom:10}}>
                                    <Stack.Item grow={1}>
                                        <h5>Fotos de art&iacute;culos</h5><small>{`Articulos: ${dataArticulos.length} - Sin foto: ${dataArticulos.filter(x=>x.imageID==='nophoto').length}`}</small>
                                    </Stack.Item>
                                    <IconButton appearance="primary" color="green" icon={<RefreshImageIcon />} onClick={() => fetchReloadPhoto() }>
                                        Releer fotos
                                    </IconButton>
                                </Stack>
                                <Stack spacing={10} justifyContent="flex-end" direction="row">
                                    <Stack.Item grow={1}>
                                        <RadioGroup name="radioList" inline appearance="picker" value={filterPhoto} defaultValue="A" style={{ border: 0 }} onChange={(s) => setFilterPhoto(s)}>
                                            <span style={{ padding: '7px 2px 7px 12px', display: 'inline-block', verticalAlign: 'middle' }}>Mostrar: </span>
                                            <Radio value="A">Todos</Radio>
                                            <Radio value="B">Con foto</Radio>
                                            <Radio value="C">Sin foto</Radio>
                                        </RadioGroup>
                                    </Stack.Item>
                                    <InputGroup size="md" inside style={{ width: 200 }}>
                                        <Input placeholder="Filtrar art&iacute;culo" onChange={e => setFilterArticulo(e.toLowerCase())} />
                                        <InputGroup.Button>
                                            <SearchIcon />
                                        </InputGroup.Button>
                                    </InputGroup>
                                    <InputGroup size="md" inside style={{ width: 200 }}>
                                        <Input placeholder={'Filtrar rubro'} onChange={e => setFilterRubro(e.toLowerCase())} />
                                        <InputGroup.Button>
                                            <SearchIcon />
                                        </InputGroup.Button>
                                    </InputGroup>
                                    <InputGroup size="md" inside style={{ width: 200 }}>
                                        <Input placeholder={'Filtrar subrubro'} onChange={e => setFilterSubRubro(e.toLowerCase())} />
                                        <InputGroup.Button>
                                            <SearchIcon />
                                        </InputGroup.Button>
                                    </InputGroup>
                                </Stack>
                                <Divider />
                                <Table rowKey="value" autoHeight data={articulos} id="tablePreview" affixHeader virtualized
                                    sortColumn={sortColumn} locale={{ emptyMessage: "No se econtraron resultados...", loading: "Cargando art�culos ..." }}
                                    sortType={sortType} rowHeight={80} hover={false}
                                    onSortColumn={handleSortColumn}>
                                    <Column width={80} align="center">
                                        <HeaderCell></HeaderCell>
                                        <ImageCellProduct dataKey="image" />
                                    </Column>
                                    <Column width={80} sortable>
                                        <HeaderCell align="center">C&oacute;digo</HeaderCell>
                                        <Cell align="center" dataKey="value" />
                                    </Column>
                                    <Column flexGrow={2} sortable>
                                        <HeaderCell>Art&iacute;culo</HeaderCell>
                                        <Cell dataKey="label" />
                                    </Column>
                                    <Column flexGrow={1} sortable>
                                        <HeaderCell align="left">C&oacute;digo</HeaderCell>
                                        <Cell align="left" dataKey="rubro" />
                                    </Column>
                                    <Column flexGrow={1} sortable>
                                        <HeaderCell align="left">C&oacute;digo</HeaderCell>
                                        <Cell align="left" dataKey="subrubro" />
                                    </Column>
                                </Table>
                            </Col>
                        )}
                    </Row>
                )}
            </Panel>
        </>
    );
}
export default Settings;